import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  float: left;
  display: flex;
  flex-direction: row;
  border-top: 0.2rem solid rgba(255,255,255, 0.05);
  padding: 1rem 0 0 0;
  align-items: center;

  @media (max-width: 1024px) {
  }
`;
